// extracted by mini-css-extract-plugin
export default {"pageLoader":"InfoPage_pageLoader__rptL4"};